import { QueryClientProvider, type QueryClient } from '@tanstack/react-query'
import { useState, type ReactNode } from 'react'
import type { Api } from './api'
import { ApiContext } from './api-context'
import type { AuthClient } from './auth'
import { createQueryClient } from './query-client'
import { RealtimeContext, type RealtimeClient } from './realtime'
import { SessionProvider } from './session-provider'

/**
 * Tudo que uma página precisa em volta: cache de leitura (TanStack Query), cliente da API e sessão.
 * `main.tsx` passa o cliente e o Supabase Auth reais; testes e stories passam os falsos (T25).
 */
export function AppProviders({
  api,
  auth,
  realtime = null,
  queryClient,
  children,
}: {
  api: Api
  auth: AuthClient
  /** O Realtime do Supabase (RN-ASS-32); `null` onde nada escuta. */
  realtime?: RealtimeClient | null
  queryClient?: QueryClient
  children: ReactNode
}) {
  const [client] = useState(() => queryClient ?? createQueryClient())
  return (
    <QueryClientProvider client={client}>
      <ApiContext.Provider value={api}>
        <RealtimeContext.Provider value={realtime}>
          <SessionProvider auth={auth}>{children}</SessionProvider>
        </RealtimeContext.Provider>
      </ApiContext.Provider>
    </QueryClientProvider>
  )
}
